
// First, checks if it isn't implemented yet.
if (!String.prototype.sformat) {
    String.prototype.sformat = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                    ? args[number]
                    : match
                    ;
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/prototypes/Sformat.js
// module id = 349
// module chunks = 0